<template>
  <b-card :title="$t('Teklif İste')">
    <template v-if="dataItem.items.length > 0">
      <b-list-group>
        <b-list-group-item
          v-for="item in dataItem.items"
          :key="item.id"
        >
          <b-row class="match-height d-flex align-items-center">
            <b-col
              cols="12"
              md="3"
            >
              <div class="rounded overflow-hidden">
                <b-img
                  :src="productMediaURL + item.image"
                  fluid
                />
              </div>
            </b-col>
            <b-col>
              <div class="border-bottom pb-1 mb-1">
                <div class="font-weight-bold text-primary">
                  {{ $t('Ürün Kodu') }}
                </div>
                <div class="text-muted">
                  {{ item.product_quality }}
                </div>
              </div>
              <div class="border-bottom pb-1 mb-1">
                <div class="font-weight-bold text-primary">
                  {{ $t('Kalite') }}
                </div>
                <div class="text-muted">
                  {{ item.product }}
                </div>
              </div>
              <div>
                <div class="font-weight-bold text-primary">
                  {{ $t('Birim Fiyat') }}
                </div>
                <div class="text-muted">
                  {{ item.price | toCurrency }} {{ item.currency }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="auto"
            >
              <b-button
                v-b-tooltip.hover.v-danger="$t('Listeden Kaldır')"
                variant="flat-danger"
                class="btn-icon"
                pill
                @click="removeItem(item.id)"
              >
                <FeatherIcon icon="XCircleIcon" />
              </b-button>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <hr>
      <b-form-group :label="$t('Notlar')">
        <b-form-textarea
          v-model="dataItem.notes"
          :placeholder="$t('Notlar')"
        />
      </b-form-group>
      <b-button
        variant="success"
        @click="sendRequest"
      >
        <FeatherIcon icon="SendIcon" />
        {{ $t('Teklif İste') }}
      </b-button>
    </template>
    <template v-else>
      <b-alert
        v-if="sendResult.id"
        :variant="sendResult.status === true? 'success' : 'danger'"
        show
      >
        <div class="alert-body text-center">
          <div class="mt-1 mb-1">
            <FeatherIcon
              :icon="sendResult.status === true? 'CheckCircleIcon' : 'XCircleIcon'"
              size="36"
            />
          </div>
          <div class="font-medium-2">
            {{ sendResult.message }}
          </div>
          <div
            v-if="sendResult.status === true"
            class="mt-1"
          >
            <b-button
              variant="success"
              to="/app/catalogs"
            >
              <FeatherIcon icon="BookIcon" />
              {{ $t('Kataloglarım') }}
            </b-button>
          </div>
        </div>
      </b-alert>
      <b-alert
        v-else
        variant="warning"
        show
      >
        <div class="alert-body text-center">
          <div class="font-weight-bolder font-medium-4">
            {{ $t('Teklif Listeniz Boş') }}
          </div>
          <div class="font-weight-light">
            {{ $t('Teklif talebi oluşturabilmek için katalogdan ürün ekleyin') }}.
          </div>
        </div>
      </b-alert>
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BListGroup, BListGroupItem, BImg, BRow, BCol, BButton, BFormGroup, BFormTextarea, BAlert, VBTooltip,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Request',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BImg,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormTextarea,
    BAlert,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      productMediaURL: this.$store.state.app.productMediaURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['baskets/dataItem']
    },
    saveData() {
      return this.$store.getters['baskets/dataSaveStatus']
    },
    sendResult() {
      return this.$store.getters['baskets/sendResult']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('baskets/getData')
    },
    sendRequest() {
      this.$store.dispatch('baskets/sendRequest', this.dataItem)
        .then(response => {
          if (response.status) {
            this.getData()
            this.$store.commit('baskets/RESET_DATA_ITEM')
          }
        })
    },
    removeItem(productId) {
      this.$store.dispatch('baskets/removeItem', {
        id: productId,
      })
        .then(response => {
          if (response) {
            this.getData()
          }
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
